var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('home-page-de',{attrs:{"products":{news: _vm.news, bestsellers: _vm.bestsellers, sales: _vm.sales}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }